import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { ScanItem } from '../../Unload/Unload.type';
import { generateRandom10DigitNumber } from '../../../../Utility/Utility';
import Table, { Column } from '../../../../Components/Tables/Table';
import { SubmitHandler, useForm } from 'react-hook-form';
import FormButton from '../../../../Components/Buttons/FormButton';
import { PATTERN_ERR_MSG, REQ_ERR_MSG } from '../../../../Shared/Helper/ValidationMessage';
import { ALPHA_NUM_HYPHEN_REGEX, NUMBER_REGEX } from '../../../../Shared/Helper/Constant';
import GetSvgIcon from '../../../../assets/images/svgList';
import { uloadAddData } from '../../../../Data/testData';
import MessageModal from '../../../../Components/FormTag/MessageModal';
import { unloadItemConditionList } from '../../../../Data/dropdownDataList';

export default function ReturnAddUnload() {
    const [quantity, setQuantity] = useState<number>(0);
  const [trackingNo, setTrackingNo] = useState(0);
  const [unloadSuccessMsg, setUnloadSuccessMsg] = useState("");
  const [itemData, setItemData] = useState<ScanItem>(new ScanItem());
  const [showModal, setShowModal] = useState(false);
  const [isLocationRequired, setLocationRequired] = useState(false);

  const [selectedColor, setSelectedColor] = useState(unloadItemConditionList[0].color);

  const handleSelectChange = (event: any) => {
    const selectedOption = unloadItemConditionList.find(item => item.value === event.target.value);
    if (selectedOption) {

      setSelectedColor(selectedOption.color);
    }
  };
  const navigation = useNavigate();
  const handleCancelBtn = () => {
    navigation("/inbound/returns/unload");
  };
  const handelItemQuantity = (val: number) => {
    setQuantity(val);
    let numbers = generateRandom10DigitNumber(1000000000, 9999999999);
    setTrackingNo(numbers);
    if (val > 0)
      setUnloadSuccessMsg("All items have been unloaded successfully");
    else setUnloadSuccessMsg("");
  };
  const columns: Column[] = [
    {
      name: "Items",
      selector: (row: { ItemCode: { imgSrc: string; text: string } }) => (
        <div>
          {row.ItemCode.imgSrc && (
            <img
              src={require(`../../../../assets/images/${row.ItemCode.imgSrc}`)}
              alt={row.ItemCode.text}
              style={{ width: "20px", marginRight: "8px" }}
            />
          )}
          {row.ItemCode.text}
        </div>
      ),
    },
    {
      name: "UOM",
      selector: (row: { UOM: string }) => row.UOM,
    },
    {
      name: "Received Qty",
      selector: (row: { ReceivedQuantity: string }) => row.ReceivedQuantity,
    },
    {
      name: "Putaway Qty",
      selector: (row: { PutawayQuantity: string }) => row.PutawayQuantity,
    },
  ];
  

  const {
    handleSubmit,
    register,
    reset,
    control,
    watch,
    setValue,
    formState: { errors },
  } = useForm<ScanItem>({
    defaultValues: itemData,
  });
  const itemQyaWatch = watch("itemQya");
  const handleReceiveBtn: SubmitHandler<ScanItem> = (data) => {
    setLocationRequired(false);
    console.log(data);
    navigation("/inbound/returns/receive");
  };
  const handleSaveBtn: SubmitHandler<ScanItem> = (data) => {
    setLocationRequired(true);

    handleCloseModal();
  };
  const handelActionOnCancel = () => {
    handleCloseModal();
  };
  const handelActionOnSuccess: SubmitHandler<ScanItem> = (data) => {
    handleCloseModal();
    navigation("/inbound/returns/unload");
  };
  const handleCloseModal = () => {
    setValue("location", "");
    setShowModal(!showModal);
  };
  const footer = (
    <>
      <div className="my-2 bg-white rounded">
        <div className="d-flex ">
          <FormButton
            className="sph-btn sph-shift me-4"
            handleClick={handelActionOnCancel}
          >
            Close
          </FormButton>
          <FormButton
            className="sph-btn me-4"
            handleClick={handleSubmit(handelActionOnSuccess)}
          >
            Submit
          </FormButton>
          
        </div>
      </div>
    </>
  );
  
  return (
    <div>
       <div className="d-flex flex-column h-100">
      <div className="d-flex justify-content-start mt-3">
        <div className="col">
          <div className="top-tab p-3">
            <div className="">
              ASN: <strong>B5487996</strong>
            </div>
          </div>
        </div>
        <div className="col mx-2">
          <div className="top-tab p-3">
            <div className="">
              Location: <strong>19-Door</strong>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="top-tab p-3">
            <div className="">
              Warehouse: <strong>Area-12</strong>
            </div>
          </div>
        </div>
        <div className="col mx-2"></div>
      </div>
      <div className="d-flex justify-content-between my-3">
        <div className="col d-flex flex-column justify-content-between scanning-area">
          <div className="d-flex align-items-center justify-content-around scanning-area-top">
            Enter Quantity
          </div>
          {
              quantity !==0 && (
                <div className="item-condition-div d-flex justify-content-between py-2 px-3 position-relative">
                  <label>
                    Select Item Condition
                  </label>
                  <select
                    className="custom-dropdown colouredOption position-absolute end-0 w-100"
                    style={{ color: selectedColor }}
                    onChange={handleSelectChange}
                  >
                    {unloadItemConditionList.map((item) => (
                      <option key={item.value} value={item.value} style={{ color: item.color }}>
                        {item.label}
                      </option>
                    ))}
                  </select>
                </div>
              )
            }
          <div className="bg-white p-4 scanning-area-bottom">
            <div className="input-group">
              <input
                type="text"
                className="form-control rounded-start-pill  border border-info border-end-0 p-3 scanner-input"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-lg"
                placeholder="Scan or enter Item quantity"
                onKeyDown={(e) => {
                  if (e.key === "Tab" || e.key === "Enter") {
                    handelItemQuantity(
                      Number((e.target as HTMLInputElement).value)
                    );
                  } else if (e.key === "Backspace" || e.key === "Delete") {
                    handelItemQuantity(0);
                    setTrackingNo(0);
                  }
                }}
                {...register("itemQya", {
                  required: { value: true, message: REQ_ERR_MSG },
                  pattern: {
                    value: NUMBER_REGEX,
                    message: PATTERN_ERR_MSG,
                  },
                })}
              />
              <span
                className="input-group-text rounded-end-pill bg-white border border-info border-start-0 cursor-pointer"
                id="inputGroup-sizing-lg"
              >
                {GetSvgIcon.UpcScanner}
              </span>
            </div>
            {errors && (
              <div>
                <span className="text-danger "> {errors?.itemQya?.message}</span>
              </div>
            )}
          </div>
          <div className="d-flex justify-content-between mt-2">
            <div className="col me-1">
              <div className="top-tab p-3 d-flex justify-content-between">
                <div className="">
                  <strong>Quantity:</strong>
                </div>
                <div className="">
                  <strong>{quantity > 0 ? quantity : ""}</strong>
                </div>
              </div>
            </div>
            <div className="col ms-1">
              <div className="top-tab p-3 d-flex justify-content-between">
                <div className="">
                  <strong>Tracking#:</strong>
                </div>
                <div className="">
                  <strong>{trackingNo > 0 ? trackingNo : ""}</strong>
                </div>
              </div>
            </div>
          </div>
          {unloadSuccessMsg !== "" && (
            <>
              <div className="d-flex justify-content-between mt-2">
                <div className="col me-1">
                  <div className="top-tab p-3 d-flex justify-content-center">
                    <div className="msg-wrapper">
                      <div className="col-12 d-flex justify-content-center mt-5">
                        {GetSvgIcon.ScannerSuccessLogo}
                      </div>

                      <div className="col-12 mt-3 mb-5">
                        <strong>{unloadSuccessMsg}</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="col-8 ms-2">
          <div className="top-tab h-100 p-2">
            {quantity > 0 ? (
              <Table
                columns={columns}
                data={uloadAddData}
                CheckboxStatus={false}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <div className="mt-auto bg-white rounded py-3">
        <div className="d-flex justify-content-between">
          <FormButton
            tabIndex={12}
            className="sph-btn sph-shift ms-4"
            handleClick={handleSubmit(handleReceiveBtn)}
          >
            Receive
          </FormButton>
          <div className="d-flex">
            <FormButton
              tabIndex={12}
              className="sph-btn sph-shift me-4"
              handleClick={handleCancelBtn}
            >
              Close
            </FormButton>
            <FormButton
              tabIndex={11}
              className="sph-btn me-4"
              handleClick={handleSubmit(handleSaveBtn)}
            >
              Submit
            </FormButton>
            
          </div>
          <MessageModal
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            messageLabel="Scan or Enter unload location"
            footer={footer}
          >
            <div className="input-group mt-3">
              <input
                type="text"
                className="form-control rounded-start-pill  border border-info border-end-0 py-3 px-3 fs-14 scanner-input"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-lg"
                placeholder="Scan or Enter unload location"
                {...register("location", {
                  required: {
                    value: isLocationRequired && !!itemQyaWatch,
                    message: REQ_ERR_MSG,
                  },
                  pattern: {
                    value: ALPHA_NUM_HYPHEN_REGEX,
                    message: PATTERN_ERR_MSG,
                  },
                })}
              />
              <span
                className="input-group-text rounded-end-pill bg-white border border-info border-start-0 cursor-pointer"
                id="inputGroup-sizing-lg"
              >
                {GetSvgIcon.UpcScanner}
              </span>
            </div>
            {errors && (
              <div>
                <span className="text-danger fs-14 fw-normal">
                  {" "}
                  {errors?.location?.message}
                </span>
              </div>
            )}
          </MessageModal>
        </div>
      </div>
    </div>
    </div>
  )
}
